{
  "_note": "AUTO-GENERATED by scripts/generate-typography-catalog.mjs — DO NOT EDIT. Source of truth: src/<sourceDir>/typography.ts (TYPE_PAIRS + FONT_FALLBACKS). Regenerate: (cd remotion-service/templates && node scripts/generate-typography-catalog.mjs)",
  "template": "language_learning",
  "pairs": {
    "default": {
      "display": {
        "family": "Lora",
        "fallback": "serif",
        "weight": 700,
        "italic": false,
        "letterSpacing": null,
        "textTransform": "none"
      },
      "body": {
        "family": "Figtree",
        "fallback": "sans-serif",
        "weight": 500,
        "italic": false,
        "letterSpacing": null,
        "textTransform": "none"
      }
    },
    "crisp_didactic": {
      "display": {
        "family": "Inter",
        "fallback": "sans-serif",
        "weight": 700,
        "italic": false,
        "letterSpacing": null,
        "textTransform": "none"
      },
      "body": {
        "family": "Inter",
        "fallback": "sans-serif",
        "weight": 500,
        "italic": false,
        "letterSpacing": null,
        "textTransform": "none"
      }
    },
    "notebook": {
      "display": {
        "family": "Caveat",
        "fallback": "cursive",
        "weight": 700,
        "italic": false,
        "letterSpacing": null,
        "textTransform": "none"
      },
      "body": {
        "family": "Lora",
        "fallback": "serif",
        "weight": 500,
        "italic": false,
        "letterSpacing": null,
        "textTransform": "none"
      }
    },
    "editorial_warm": {
      "display": {
        "family": "Playfair Display",
        "fallback": "serif",
        "weight": 700,
        "italic": false,
        "letterSpacing": null,
        "textTransform": "none"
      },
      "body": {
        "family": "Lato",
        "fallback": "sans-serif",
        "weight": 500,
        "italic": false,
        "letterSpacing": null,
        "textTransform": "none"
      }
    }
  }
}
